import { useParams } from "react-router-dom";
import { MuiPage } from "../../../components";
import { MuiAccordionArray } from "../../../components/MuiAccordionArray";
import FeaturesEdit from "./features.edit";
import { FeatureRolesMapping } from "./featuresAccordian/feature.role";
import { FeatureAccess } from "./featuresAccordian/features.featuresAccess";
import { getLocalStorageItem } from "../../../utils/storageHelper";


export const FeaturesAddEdit = () => {
    const { id: FeatureId } = useParams()
    const ApplicationId = getLocalStorageItem('ApplicationId')

    const accordionArray = [
        {
            panelId: 'Panel1',
            name: ("Role"),
            child: <FeatureRolesMapping request={{ FeatureId, ApplicationId }} />
        },
        {
            panelId: 'Panel2',
            name: ("Feature Access"),
            child: <FeatureAccess request={{ FeatureId, ApplicationId }} />
        },
    ]

    return (
        <MuiPage>
            <FeaturesEdit />
            {!!FeatureId && (
                <MuiAccordionArray
                    accordionArray={accordionArray}
                />
            )}
        </MuiPage>
    );
}